
<div class="ttmodal">
  <div class="ttmodal__header">
      <span class="ttmodal__title">Select Action</span>
      <i class="material-icons ttmodal__close-button" (click)="onNoClick()">close</i>
  </div>

  <div class="ttmodal__body" >
      <button class="button button--primary" style="color: white;" (click)="Open()" >Inspect and/or Repair</button> OR 
      <button *ngIf="data.item.SystemType==1" class="button button--primary" style="color: white;"  (click)="StartInspection()" >Undercarriage Rebuild Centre</button>
      <button *ngIf="data.item.SystemType==2" class="button button--primary" style="color: white;"  (click)="StartInspectionFrame()" >Undercarriage Rebuild Centre</button>
      <button *ngIf="data.item.SystemType==3" class="button button--primary" style="color: white;"  (click)="StartInspection()" >Idler Rebuild</button>

    </div>

 
</div>